import type { ReceiptTemplate } from '../schema';

export const oldNavyTemplate: ReceiptTemplate = {
  id: 'old-navy',
  name: 'Old Navy Receipt',
  brand: 'OLD NAVY',
  description: 'Old Navy clothing store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'on-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/old-navy.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'on-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'on-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'GRAPHIC TEE', quantity: '2', price: '12.99', sku: '847291034' },
          { id: '2', name: 'ROCKSTAR JEANS', quantity: '1', price: '34.99', sku: '847291035' },
          { id: '3', name: 'FLEECE HOODIE', quantity: '1', price: '29.99', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'on-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '90.96', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '7.50', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '98.46', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'on-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'OLD NAVY CARD ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'on-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'REWARDS MEMBER\n\nReturns within 45 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

